import cx from "classnames";
import type { ReactElement } from "react";

type Props = Readonly<{
  time: string;
  className?: string;
}>;

export default function TimeCode({ time, className }: Props): ReactElement {
  return (
    <div
      data-testid="time-code"
      className={cx(
        "bg-background-primary-on-dark text-primary-on-dark text-label-2 inline-block rounded-[5px] px-2 py-0.5 font-bold",
        className,
      )}
    >
      <span>{time}</span>
    </div>
  );
}
